import _ from "lodash";
import React from "react";
import {
  COLUMN_TYPES,
  ERROR_TYPE_TO_MESSAGE_LOCALE,
  TAB_TYPES,
} from "./constants";
import { Badge } from "@toddle-edu/ds-web";
import { getFormattedUserName } from "Utils/GetFormattedUserName";

export const getTabOptions = ({ t, skipped, applied }) => {
  const result = [];

  if (!_.isEmpty(skipped)) {
    result.push({
      value: TAB_TYPES.SKIPPED,
      label: t("common:skipped"),
      suffix: (
        <Badge
          shape="circle"
          type="numeric"
          value={_.size(skipped)}
          variant="notifications"
        />
      ),
    });
  }

  if (!_.isEmpty(applied))
    result.push({
      value: TAB_TYPES.APPLIED,
      label: t("transcript:configuration_applied"),
      suffix: (
        <Badge
          shape="circle"
          type="numeric"
          value={_.size(applied)}
          variant="subtle"
        />
      ),
    });

  return result;
};

/**
 * Helper function to parse error messages and extract grade level names
 * Handles multiple error messages with grade level information
 */
export const parseErrorMessages = ({ errors, errorsLocales, id }) => {
  return _.map(errors, ({ errorType, grades }) => {
    const gradeNames = _.map(grades, "name");

    return {
      gradeLevels: gradeNames,
      errorMessage: errorsLocales[errorType],
      key: `${errorType}-${id}`,
    };
  });
};

export const getCurrentTabData = ({ selectedTab, skipped, applied, t }) => {
  const currentTabData = selectedTab === TAB_TYPES.SKIPPED ? skipped : applied;
  const errorsLocales = {};
  _.forEach(ERROR_TYPE_TO_MESSAGE_LOCALE, (messageLocale, errorType) => {
    errorsLocales[errorType] = t(messageLocale, { label: "" });
  });

  return _.map(currentTabData, ({ grades, student, errors }) => {
    const { id, profileImage } = student || {};
    const studentName = getFormattedUserName({ user: student });

    const rowData = {
      id,
      [COLUMN_TYPES.STUDENT_NAME]: {
        label: studentName,
        showAvatar: true,
        src: profileImage,
        avatarId: id,
      },
    };

    if (selectedTab === TAB_TYPES.SKIPPED) {
      rowData[COLUMN_TYPES.ERROR] = parseErrorMessages({
        errors,
        errorsLocales,
        id,
      });
    } else {
      rowData[COLUMN_TYPES.GRADE_LEVELS_APPLIED] = {
        gradeLevels: _.map(grades, "name"),
      };
    }

    return rowData;
  });
};
